import React from 'react'
import { useTranslation } from 'react-i18next'
import cn from 'classnames'

import { Input, SvgResource, TextContentEditable } from 'components'
import styleInput from 'components/Input/Input.module.css'
import styleForm from 'styles/modules/form.module.css'
import style from './TicketMessageForm.module.css'

export type FormDataType = {
    message: string
}

export type TicketMessageFormPropType = {
    classes?: string
    data: FormDataType
    isSubmitting: boolean
    onChange: (message: string) => void
    onAddAttach: (file: File) => void
    onSubmit: (message: string) => void
}

const ACCEPT_IMAGE = 'image/jpeg,image/png,image/bmp,image/gif,video/mp4'
// TODO refactoring with CommentForm
const TicketMessageForm: React.FC<TicketMessageFormPropType> = ({
    classes,
    data,
    isSubmitting,
    onChange,
    onAddAttach,
    onSubmit,
}) => {
    const { message = '' } = data

    const { t } = useTranslation()

    const handlerSubmit = (e: React.SyntheticEvent<HTMLFormElement>) => {
        e.preventDefault()
    }

    const handlerSubmitByEnter = (text: string) => {
        onSubmit(text)
    }

    const handlerChangeContent = (text: string) => {
        onChange(text)
    }

    const handlerClickAttach = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { files } = e.target
        const [file] = files || []

        if (file) {
            onAddAttach(file)
        }
    }

    return (
        <form className={cn(style.form, { [styleForm.submitting]: isSubmitting }, classes)} onSubmit={handlerSubmit}>
            <TextContentEditable
                classes={cn(style.input, styleInput.gray)}
                value={message}
                placeholder={t('Add comment')}
                onChange={handlerChangeContent}
                onSubmitByEnter={handlerSubmitByEnter}
            />

            <div className={style.actions}>
                <label
                    className={cn(styleForm.field, styleForm.field_attachIcon)}
                    title={t('add_attach')}
                >
                    <Input
                        classes={styleForm.inputFile}
                        type="file"
                        styleType="clear"
                        accept={ACCEPT_IMAGE}
                        onChange={handlerClickAttach}
                    />
                    <SvgResource
                        isImgTag={false}
                        classes={style.iconAttach}
                        resourceKey="ic_attach_svg"
                        width={26}
                        height={32}
                    />
                </label>
            </div>
        </form>
    )
}

export default TicketMessageForm
